import styled from 'styled-components';

const PopupContent = styled.div`
    position: absolute;
    bottom: 0;
    visibility: hidden;
    top: calc(100% - 0.5rem);
    right: 1rem;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgb(0 0 0 / 30%);
    z-index: 1;
    @media (min-width: 1168px) {
        min-width: 20%;
    }
`;

export default PopupContent;
